import React, { useEffect, useState } from 'react'
import { MapMarker } from './MapMarker/MapMarker'
import styled, { keyframes } from 'styled-components'
import { ThemeColors } from '@evrekadev/evreka-ui-components'

export const CurrentLocation: React.FC = () => {
  const [location, setLocation] = useState<GeolocationPosition | null>(null)

  useEffect(() => {
    if (!navigator.geolocation) {
      console.warn('Geolocation is not supported')
    } else {
      const options: PositionOptions = {
        enableHighAccuracy: true, // Use GPS if possible
        maximumAge: 1000 * 60 * 5, // Allow caching of position for 5 minutes
        timeout: 10000, // Wait at most 5 seconds for location
      }

      // Start watching position
      const watchId = navigator.geolocation.watchPosition(
        setLocation,
        (err) => console.warn(err),
        options,
      )

      // Cleanup function: Stop watching when component unmounts
      return () => {
        navigator.geolocation.clearWatch(watchId)
      }
    }
  }, [])

  return location ? (
    <MapMarker
      id="_current_locaiton"
      marker={{
        position: {
          lat: location.coords.latitude,
          lng: location.coords.longitude,
        },
      }}
      disablePopup
      icon={{
        idle: <LocationMarker />,
        anchor: { idle: [6, 6] },
        size: { idle: [12, 12] },
      }}
    />
  ) : null
}

const pulse = keyframes`
  0%, 50% {
    outline-width: 6px;
  }
  100% {
    outline-width: 2px;
  }
`

const LocationMarker = styled.div`
  height: 12px;
  width: 12px;
  background-color: ${ThemeColors.blue500};
  border-radius: 50%;
  border: 1px solid ${ThemeColors.white};
  outline: 6px solid rgba(18, 164, 237, 0.25);
  animation: ${pulse} 1s infinite alternate ease-in-out;
`
